<template>
    <widget :title="title" :router="router">
        <div class="table_switch">
            <span class="float_left mar_left" @click="weekPrev" v-if="teachingWeekList.length > 1 && weekNum > 1 && weekNum < teachingWeekList.length">
                <i class="el-icon-caret-left"></i><span class="week_name">上周</span>
            </span>
            <span v-if="currentTeachingWeek">{{currentTeachingWeek.startTime | dateFilter}} 至 {{currentTeachingWeek.endTime | dateFilter}}</span>
            <span class="float_right mar_right" @click="weekNext" v-if="teachingWeekList.length > 1 && weekNum < teachingWeekList.length">
                <span class="week_name">下周</span><i class="el-icon-caret-right"></i>
            </span>
        </div>
        <div class="table_box">
            <table class="time_table">
                <tr>
                    <td colspan="2">课节</td>
                    <td v-for="(day,dayIndex) in weekTemplent.days" :key="dayIndex">{{week[day]}}</td>
                </tr>
                <tr v-for="(row,rowIndex) in lessonNum" :key="rowIndex">
                        <td v-if="rowIndex == 0 && weekTemplent.morning" :rowspan="weekTemplent.morning">早上</td>
                        <td v-else-if="(rowIndex + 1 == weekTemplent.morning + 1) && weekTemplent.forenoon" :rowspan="weekTemplent.forenoon">上午</td>
                        <td v-else-if="(rowIndex + 1 == weekTemplent.morning + weekTemplent.forenoon + 1) && weekTemplent.afternoon" :rowspan="weekTemplent.afternoon">下午</td>
                        <td v-else-if="(rowIndex + 1 == weekTemplent.morning + weekTemplent.forenoon + weekTemplent.afternoon + 1) && weekTemplent.evening" :rowspan="weekTemplent.evening">晚上</td>
                        <!-- <td v-else></td> -->
                        <td>
                            <div>
                                <p>{{rowIndex + 1}}</p>
                            </div>
                        </td>
                        <td v-for="(timetable,tdIndex) in weekTemplent.days.length" class="td_bg_white" :key="tdIndex">
                            <template v-if="tableInfoList.length > 0">
                                <div v-for="(list,index) in tableInfoList" v-if="list.lessonNum == rowIndex && list.weekDay == tdIndex" :key="index">
                                    <div>
                                        <div class="class" >{{list.teachingClassName}}</div>
                                        <div class="calss_info">{{list.courseName}}</div>
                                    </div>
                                </div>
                            </template>
                        </td>
                    </tr>
            </table>
        </div>
    </widget>
</template>
<script>
    import widget from './warp'
    import widgetFilter from './widgetFilter.js'
    export default {
        components: {
            widget,
        },
        props:{
            title:{
                type:String
            },
            swWidth:{
                type:Number
            },
            item:{
                type:Object
            }
        },
        filters:{
            dateFilter:function(val){
                let str = ''
                if(val){
                    let data = new Date(val)
                    let Month = parseInt(data.getMonth()) + 1
                    str = data.getFullYear() + '-' + Month + '-' + data.getDate() + ' '
                }
                return str
            }
        },
        data(){
            return {
                widgetType:1,
                router:'arrange_table_teacher',
                configList:null,
                widgetUrl:'',
                tableData:{},
                weekTemplent:{
                    days:[0,1,2,3,4],
                    morning:1,
                    forenoon:4,
                    afternoon:3,
                    evening:2
                },
                tableInfoList:[],
                lessonNum:10,
                currentTeachingWeek:null,
                week:['星期一','星期二','星期三','星期四','星期五','星期六','星期日'],
                teachingWeekList:[],
                teachWeekId:'',
                weekNum:1,
                schoolId:window.appframe.$store.state.userInfo.schoolId,
                campusId:window.appframe.$store.state.userInfo.campusId
            }
        },
        mounted(){
            let vm = this
            vm.$nextTick(function(){
                 vm.widgetType = _.cloneDeep(vm.swWidth)
                if(vm.item.configList.length > 0){
                    let configList = vm.item.configList
                    vm.configList = widgetFilter.getFieldMap(configList)
                    let stemp = []
                    for(let i in vm.configList){
                        stemp.push(vm.configList[i])
                    }
                    vm.widgetUrl = stemp[0].apiUrl
                    vm.queryWeekList()
                }
            })
        },
        methods: {
            queryWeekList(){
                let vm = this
                if(vm.schoolId != '' && vm.campusId != ''){
                    let obj = {
                        schoolId:vm.schoolId,
                        campusId:vm.campusId
                    }
                    http.get('/gateway/arrange-course/widget/courseTableData',{params:obj}).then(function(xhr){

                        let objectA = xhr.data
                        let simpleMap = widgetFilter.getFieldMap(vm.item.columns)
                        var newObj = new Object();
                        vm.tableData = widgetFilter.showProps(objectA,'',simpleMap,newObj)
                        
                        vm.teachingWeekList = vm.tableData.teachingWeekList
                        vm.currentTeachingWeek = vm.tableData.currentTeachingWeekInfo
                        vm.weekNum = (vm.currentTeachingWeek && vm.currentTeachingWeek.weekNumInfo) ? vm.currentTeachingWeek.weekNumInfo : 1
                        vm.teachWeekId = (vm.currentTeachingWeek && vm.currentTeachingWeek.weekId) ? vm.currentTeachingWeek.weekId : ''
                        vm.query()
                    })
                }
            },
            query(){
                let vm = this
                let obj = {
                    schoolId:vm.schoolId,
                    campusId:vm.campusId,
                    teachingWeekId:vm.teachWeekId,
                    weekNum:vm.weekNum
                }
                http.get('/gateway/arrange-course/widget/courseTableData',{params:obj}).then(function(xhr){
                    let objectA = xhr.data
                    let simpleMap = widgetFilter.getFieldMap(vm.item.columns)
                    var newObj = new Object();
                    vm.tableData = widgetFilter.showProps(objectA,'',simpleMap,newObj)
                    if(vm.tableData.classFestivalTemplate){
                        vm.weekTemplent = {
                            days:vm.tableData.classFestivalTemplate.weekDays.split(","),
                            morning:vm.tableData.classFestivalTemplate.morningLessonNum,
                            forenoon:vm.tableData.classFestivalTemplate.forenoonLessonNum,
                            afternoon:vm.tableData.classFestivalTemplate.afternoonLessonNum,
                            evening:vm.tableData.classFestivalTemplate.eveningLessonNum
                        }
                    }
                    vm.tableInfoList = vm.tableData.teacherTableLists
                    vm.lessonNum = vm.weekTemplent.morning + vm.weekTemplent.forenoon + vm.weekTemplent.afternoon + vm.weekTemplent.evening
                })
            },
            weekPrev(){
                let vm = this
                let currenwWeekNum = parseInt(vm.weekNum) - 1
                for(let i=0;i<vm.teachingWeekList.length;i++){
                    if(currenwWeekNum == vm.teachingWeekList[i].weekNumInfo){
                        vm.teachWeekId = vm.teachingWeekList[i].wekId
                        vm.weekNum = vm.teachingWeekList[i].weekNumInfo
                        vm.query()
                        break
                    }
                }
            },
            weekNext(){
                let vm = this
                let currenwWeekNum = parseInt(vm.weekNum) + 1
                for(let i=0;i<vm.teachingWeekList.length;i++){
                    if(currenwWeekNum == vm.teachingWeekList[i].weekNumInfo){
                        vm.teachWeekId = vm.teachingWeekList[i].wekId
                        vm.weekNum = vm.teachingWeekList[i].weekNumInfo
                        vm.query()
                        break
                    }
                }
            }
        }
    }
</script>
<style scoped lang="less">
    .table_switch{
        text-align: center;
        margin-top: 10px;
        color: #666;
        .mar_left{
            color: #4183FC;
            cursor:pointer;
            i{
                color:#BFCBD9;
            }
        }
        .mar_right{
            color: #4183FC;
            cursor: pointer;
            i{
                color:#BFCBD9;
            }
        }
    }
    @media screen and (max-width: 1440px) {
        .week_name{
            display: none;
        }
    }
    .table_box{
        height: 250px;
        overflow: auto;
    }
    .time_table{
        width: 100%;
        margin-top: 6px;
        background: #EDF3FE;
        text-align: center;
        color: #333;
        margin-bottom: 19px;
        tr{
            height: 30px;
            td:nth-child(1){
                width: 20px;
                padding: 0 10px;
            }
        }
        td{
            border: 1px solid #E5E5E5;
            font-size: 12px;
            .class{
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
            }
        }
        .td_bg_white{
            background: #fff;
            font-size: 12px;
            line-height: 12px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/widget/timeTable.vue